import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { take } from 'rxjs';
import { toNumber, toStringOrUndefined } from '../../subscription-form.utils';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'contigency-garanties',
    templateUrl: './contigency-garanties.component.html',
    styleUrls: ['./contigency-garanties.component.scss'],
    standalone: false
})
export class ContigencyGarantiesComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  parameters;
  baremeOptions: { id: string; value: string }[] = [];
  fraisGenerauxPlaceholder = '0';
  decesPtiaPlaceholder = '0';

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.subscriptionFacade.initForm(this, { ...this.parameters });

    this.productDao.getBaremeInvaliditeRef().pipe(take(1)).subscribe(data => {
      this.baremeOptions = data;
    });

    // Charger les min/max du produit pour les placeholders
    const productId = pledge?.products?.[0]?.productId;
    if (productId) {
      this.productDao.getProductById(productId).pipe(take(1)).subscribe(product => {
        if (product?.prevoyanceFraisGenerauxMin != null && product?.prevoyanceFraisGenerauxMax != null) {
          this.fraisGenerauxPlaceholder = `${product.prevoyanceFraisGenerauxMin} - ${product.prevoyanceFraisGenerauxMax}`;
        }
        if (product?.prevoyanceMontantMin != null && product?.prevoyanceMontantMax != null) {
          this.decesPtiaPlaceholder = `${product.prevoyanceMontantMin} - ${product.prevoyanceMontantMax}`;
        }
      });
    }
  }

  onSubmit() {
    const pledge = this.subscriptionFacade.getPledge();
    const params = this.products?.get('0')?.get('parameters')?.value;
    const productParams = pledge?.products?.[0]?.parameters;
    const devisId = productParams?.devisRecommandeId;

    if (pledge && params && devisId) {
      const body = {
        productId: pledge.products?.[0]?.productId,
        ownerId: pledge.owners?.[0]?.ownerId || pledge.owners?.[0]?.id,
        cotisation: toNumber(productParams?.monthlyPayment),
        cotisationPeriode: productParams?.cotisationPeriode,
        ...(toStringOrUndefined(params.commentaire) && { commentaire: params.commentaire }),
        enComplementRegimeObligatoire: true,
        ...(toNumber(params.ittMontantMensuel) != null && { ittMontantMensuel: toNumber(params.ittMontantMensuel) }),
        ...(toNumber(params.ittFraisGenerauxMensuels) != null && { ittFraisGenerauxMensuels: toNumber(params.ittFraisGenerauxMensuels) }),
        ...(toStringOrUndefined(params.ittFranchises) && { ittFranchises: params.ittFranchises }),
        ...(params.ittRenfortDos != null && { ittRenfortDos: params.ittRenfortDos }),
        ...(params.ittAffectionPsy != null && { ittAffectionPsy: params.ittAffectionPsy }),
        ...(toStringOrUndefined(params.ittDelaisAttente) && { ittDelaisAttente: params.ittDelaisAttente }),
        ...(params.ittMiTempsTherapeutique != null && { ittMiTempsTherapeutique: params.ittMiTempsTherapeutique }),
        ...(toNumber(params.invaliditeMontantMensuel) != null && { invaliditeMontantMensuel: toNumber(params.invaliditeMontantMensuel) }),
        ...(toStringOrUndefined(params.invaliditeBareme) && { invaliditeBareme: params.invaliditeBareme }),
        ...(toNumber(params.invaliditeSeuilDeclenchement) != null && { invaliditeSeuilDeclenchement: toNumber(params.invaliditeSeuilDeclenchement) }),
        ...(toNumber(params.decesPtiaMontant) != null && { decesPtiaMontant: toNumber(params.decesPtiaMontant) }),
        ...(toStringOrUndefined(params.cotisationMensuelle) && { cotisationMensuelle: params.cotisationMensuelle }),
        ...(toStringOrUndefined(params.cotisationMadelin) && { cotisationMadelin: params.cotisationMadelin }),
      };
      this.productDao.updatePrevoyanceDevis(Number(pledge.accountId), devisId, body)
        .pipe(take(1))
        .subscribe({ error: () => this.notificationService.error('La mise à jour du devis prévoyance a échoué') });
    }
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
